import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      // rule: [],
      formFunctionCode: 'add_tack_order',
    };
  },
  methods: {

    // 设置规则
    setRule(item) {
      return item;
    },

    // 渲染完成后执行
    formComplete() {
      this.disabled(true, ['redemptionProductName', 'redemptionProductQuantity', 'redemptionProductUnit', 'unit']);
      const { code, row } = this.formConfig;
      console.log(row);
      this.setValue({
        redemptionProductName: row.exchangeProductName,
        redemptionProductQuantity: row.redemptionProductQuantity,
        redemptionProductUnit: row.redemptionProductUnit,
        unit: row.unit,
      });
    },
    // 提交
    submit() {
      let formData = this.getFormData(); // 获取表单的值
      if (formData) {
        formData = {
          ...formData,
        };
        // 默认新增
        const url = '/cps/v1/memberIntegralOrderInfo/memberIntegralOrderInfo/maintainTheWaybillNumber';
        // 有id
        if (this.formConfig.row.id) {
          formData.id = this.formConfig.row.id;
        }
        request.post(url, formData).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
